export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8136.c4d48714.jpg";